import 'slick-carousel';
import $ from 'jquery';

export default function() {
  function init() {
    _galleryCarousel();
  }

  function _galleryCarousel() {
    var numSlick = 0;
    $('.gallery-carousel .slider-products').each(function() {
      numSlick++;
      $(this)
        .addClass('slider-' + numSlick)
        .slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: $(this).data('show-arrow') == 'yes',
          asNavFor: '.slider-nav.slider-' + numSlick,
        });
    });

    numSlick = 0;
    $('.gallery-carousel .slider-nav').each(function() {
      const isCustomWidth = Boolean($(this).closest('.elementor-widget-gallery-carousel.variable-width').length);

      numSlick++;
      $(this)
        .addClass('slider-' + numSlick)
        .slick({
          vertical: false,
          slidesToShow: 8,
          variableWidth: isCustomWidth,
          slidesToScroll: 1,
          asNavFor: '.gallery-carousel .slider-products.slider-' + numSlick,
          arrow: true,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 6,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 5,
              },
            },
          ],
        });
    });
  }

  return {
    init: init,
  };
}
